import { useQuery } from "@tanstack/react-query";
import { queryList } from "../../utils";
import { transactionsByBookkeepingYearId } from "../../graphql/queries";
import {
  Transaction,
  TransactionsByBookkeepingYearIdQuery,
  TransactionsByBookkeepingYearIdQueryVariables,
} from "../../API";
import { approvalKeys } from "./query-keys";
import { isInboxStatus } from "../../utils/approval-status-helpers";

export const useApprovalInbox = (bookkeepingYearId: string | undefined) =>
  useQuery({
    queryKey: approvalKeys.inbox(bookkeepingYearId),
    queryFn: async () => {
      const transactions = await queryList<
        Transaction,
        TransactionsByBookkeepingYearIdQueryVariables,
        TransactionsByBookkeepingYearIdQuery
      >(transactionsByBookkeepingYearId, {
        bookkeepingYearId: bookkeepingYearId!,
      });
      return transactions.filter((transaction) =>
        isInboxStatus(transaction.approvalStatus)
      );
    },
    enabled: !!bookkeepingYearId,
  });
